import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { OnlineLayoutSettings } from 'common/modules/customization';
import * as ShopSelectors from 'selectors/ShopSelectors';
import * as UserSelectors from 'selectors/UserSelectors';
import LocationDetail from 'common/components/LocationDetail';
import useShopFormat from 'hooks/useShopFormat';
import { useTranslation } from 'services/localization';
import AboutContainer from 'common/components/AboutContainer';
import { CustomizerContext } from '../CustomizerContext';
import CustomContentContainer from 'common/components/customizer/CustomContentContainer';

export interface Props {
	about: OnlineLayoutSettings['about'];
}
const AboutPreview = (props: Props) => {
	const { about } = props;
	const { t } = useTranslation();
	const locationsById = useSelector(ShopSelectors.allShopLocationsById);
	const activeLocationId = useSelector(UserSelectors.userActiveLocationId);
	const location = locationsById[activeLocationId!]!;
	const openingHours = useSelector(ShopSelectors.activeShopOpeningHours)!;
	const { defaultTimes, exceptionDates } = openingHours;
	const { localFormat } = useShopFormat();
	const language = useSelector(ShopSelectors.activeShopDefaultLanguage);
	const { sectionId, setSectionId } = useContext(CustomizerContext);

	return (
		<Box sx={{ minHeight: '600px', py: 7 }}>
			<AboutContainer about={about} language={language} t={t}>
				<LocationDetail
					location={location}
					openingHours={defaultTimes}
					exceptionDates={exceptionDates}
					t={t}
					variant={'contact'}
					localFormat={localFormat}
					hideContact={false}
					hideExceptions={false}
					hideAdditionalInformation={false}
					hasOpeningHours={true}
					isLocationDeliveryOnly={false}
				/>
			</AboutContainer>
			<CustomContentContainer
				customContent={about?.customContent}
				sectionId={sectionId}
				setSectionId={setSectionId}
				language={language}
			/>
		</Box>
	);
};

export default AboutPreview;
